var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:_vm.className},[_c('transition',{on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter,"before-leave":_vm.beforeLeave,"leave":_vm.leave}},[_c('keep-alive',[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }